import React, { useState } from 'react';
import { object, bool, func } from 'prop-types';
import { Flex } from 'rebass';
import { ButtonStyled } from '@nike/nike-design-system-components';
import Modal from '../../modal/Modal';

const defaultModal = {
  content: null,
  title: '',
  headerTitleSlot: {},
  actions: [
    { actionName: '', action: null },
    { actionName: '', action: null }
  ]
};

export const ActionItemList = ({ selected, actionItems, isModalOpen, openModal, closeModal }) => {
  const [selectedAction, setSelectedAction] = useState(Object.keys(actionItems)[0]);
  const {
    content,
    title,
    headerTitleSlot,
    actions: [
      { actionName: actionNameSecondary, action: actionSecondary },
      { actionName: actionNamePrimary, action: actionPrimary, disabled: isActionPrimaryDisabled }
    ]
  } = actionItems[selectedAction]?.modal || defaultModal;

  const selectAction = ({ target }) => {
    openModal();
    setSelectedAction(target?.textContent);
  };

  return (
    <Flex style={{ visibility: Object.keys(selected).length ? 'visible' : 'hidden' }} data-testid='actionItems'>
      {Object.entries(actionItems).map(([name, value]) => (
        <ButtonStyled
          key={name}
          appearance='text'
          background='light'
          ariaLabel={name}
          type='button'
          onClick={value.modal ? selectAction : value.action}
          style={{ marginRight: '10px' }}
        >
          {name}
        </ButtonStyled>
      ))}

      {content && (
        <Modal
          closeModal={closeModal}
          isOpen={isModalOpen}
          content={content}
          title={title}
          headerTitleSlot={headerTitleSlot}
          footer={({ isLoading, toggleIsLoading }) => (
            <>
              <ButtonStyled
                type='button'
                appearance='primary'
                size='small'
                className='responsive-button'
                onClick={actionPrimary({ toggleIsLoading })}
                disabled={isLoading || isActionPrimaryDisabled}
                data-testid='actionItemList-primary-button'
              >
                {actionNamePrimary}
              </ButtonStyled>
              <ButtonStyled
                type='button'
                appearance='secondary'
                background='light'
                size='small'
                className='responsive-button'
                onClick={actionSecondary}
                disabled={isLoading}
                data-testid='actionItemList-secondary-button'
              >
                {actionNameSecondary}
              </ButtonStyled>
            </>
          )}
        />
      )}
    </Flex>
  );
};

ActionItemList.defaultProps = {
  isModalOpen: false,
  openModal: null,
  closeModal: null
};

ActionItemList.propTypes = {
  selected: object.isRequired,
  isModalOpen: bool,
  openModal: func,
  closeModal: func,
  actionItems: object.isRequired
};

export default ActionItemList;
